import React, { Component } from 'react';
import Icon from '../../icons/Icon';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import UserService from '../../service/UserService';
import MessageUtil from '../../util/MessageUtil';
import CustomPasswordInput from '../custom/CustomPasswordInput';
import FormicaLabel from '../custom/FormicaLabel';
import LanguageUtil from '../../util/LanguageUtil';

class AccountSecurityComponent extends Component<{}, State> {
  public state: State = new State();

  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render() {
    const { currentPassword, confirmNewPassword, newPassword } = this.state;
    return (
      <div className={'h-full w-full bg-white rounded-[10px] border border-[#BDBDBD] border-opacity-[0.5]'}>
        <div className={'text-2xl 2xl:text-3xl font-medium mx-[30px] my-[10px] text-f-black-2'}>
          {LanguageUtil.get({ id: 'common.label.security', defaultMessage: 'Security' })}
        </div>
        <div className={'bg-[#F6F8FA] h-[calc(100%-50px)] rounded-b-lg flex flex-col items-center px-8 py-4'}>
          <div className={'grid grid-cols-2'}>
            <div className={'col-span-1'}>
              <img src={'/icons/key.svg'} alt='security' />
            </div>
            <div>
              <span className={'text-2xl 2xl:text-3xl text-f-black-2 block mt-[20px]'}>
                {LanguageUtil.get({ id: 'common.label.changePassword', defaultMessage: 'Change Password' })}
              </span>
              <span className={'w-[10px] text-md 2xl:text-lg text-[#728EFF]'}>
                {LanguageUtil.get({ id: 'common.label.aboutChangePassword', defaultMessage: 'You are about the change your password.' })}
              </span>
            </div>
          </div>
          <hr className={'mt-[50px] mb-[50px] w-11/12'} />
          <div className={'w-full flex flex-col items-center justify-center bg-[#F6F8FA] rounded-b-lg'}>
            <div className={'mt-[20px] w-11/12'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'common.label.currentPassword', defaultMessage: 'Password' })} />
              <CustomPasswordInput
                value={currentPassword}
                label={LanguageUtil.get({ id: 'common.label.currentPassword', defaultMessage: 'Current Password' })}
                onChange={(e) => {
                  this.setState({ currentPassword: (e.target as HTMLInputElement).value });
                }}
              />
            </div>
            <div className={'mt-[20px] w-11/12'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'common.label.newPassword', defaultMessage: 'New Password' })} />
              <CustomPasswordInput
                value={newPassword}
                label={LanguageUtil.get({ id: 'common.label.newPassword', defaultMessage: 'New Password' })}
                onChange={(e) => {
                  this.setState({ newPassword: (e.target as HTMLInputElement).value });
                }}
              />
            </div>
            <div className={'mt-[20px] w-11/12'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'common.label.confirmNewPassword', defaultMessage: 'Confirm New Password' })} />
              <CustomPasswordInput
                value={confirmNewPassword}
                label={LanguageUtil.get({ id: 'common.label.confirmNewPassword', defaultMessage: 'Confirm New Password' })}
                onChange={(e) => {
                  this.setState({ confirmNewPassword: (e.target as HTMLInputElement).value });
                }}
              />
            </div>
            <div className={'mt-[20px] w-11/12'}>
              <button className={'bg-primary items-center flex justify-center text-white w-full h-[34px] text-sm'} onClick={this.changePassword}>
                <Icon icon={'rollback'} size={16} />
                {'  '}
                {LanguageUtil.get({ id: 'common.label.update', defaultMessage: 'Update' })}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private changePassword = async () => {
    const { currentPassword, confirmNewPassword, newPassword } = this.state;
    if (newPassword == confirmNewPassword) {
      try {
        await this.userService.resetPassword(currentPassword, newPassword);
        MessageUtil.success({
          summary: LanguageUtil.get({ id: 'messages.account.summaryPassword', defaultMessage: 'Password' }),
          detail: <div>{LanguageUtil.get({ id: 'messages.account.success', defaultMessage: 'Success' })}</div>,
        });
        this.setState({ currentPassword: '', newPassword: '', confirmNewPassword: '' });
      } catch (e) {
        MessageUtil.error({
          summary: LanguageUtil.get({ id: 'messages.account.summaryPassword', defaultMessage: 'Password' }),
          detail: <div>{LanguageUtil.get({ id: 'messages.account.updateError', defaultMessage: 'Update Error' })}</div>,
        });
      }
    } else {
      console.error('Passwords did not match');
    }
  };
}

class State {
  currentPassword: string = '';
  newPassword: string = '';
  confirmNewPassword: string = '';
}

export default AccountSecurityComponent;
